var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonutPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9324 18.3547C39.525 13.4012 37.286 8.77688 33.6522 5.38348C30.0184 1.99007 25.2502 0.0708381 20.2773 0V10.9585C22.4914 11.0418 24.5982 11.9329 26.1994 13.4632C27.8007 14.9935 28.7856 17.057 28.9678 19.2637C29.1501 21.4704 28.5171 23.6674 27.1886 25.4394C25.86 27.2113 23.9279 28.4355 21.7575 28.8805L23.5599 39.688C28.452 38.7979 32.8377 36.1208 35.864 32.1777C38.8902 28.2345 40.3404 23.3073 39.9324 18.3547Z",
    fill: "#003F7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6932 10.9585V0C16.4199 0.0513967 13.2093 0.904701 10.3429 2.48507C7.47645 4.06543 5.04186 6.32458 3.25264 9.06434C1.46342 11.8041 0.374242 14.9408 0.0806351 18.1992C-0.212972 21.4577 0.297964 24.7383 1.56863 27.7535L11.6378 23.356C11.1008 22.0061 10.8966 20.547 11.0424 19.1017C11.1881 17.6564 11.6796 16.2673 12.4754 15.0517C13.2712 13.8361 14.3478 12.8297 15.6146 12.1173C16.8813 11.4049 18.3009 11.0074 19.7536 10.9585H19.6932Z",
    fill: "#0298A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8195 23.8994L1.78052 28.3472C2.71545 30.2881 3.92995 32.0816 5.3853 33.6705C7.60888 36.0373 10.3739 37.8295 13.4431 38.8934C16.5123 39.9573 19.7939 40.2611 23.0064 39.7787L21.1939 28.961C20.7941 29.022 20.3901 29.0522 19.9856 29.0516C18.2769 29.0496 16.6035 28.5648 15.1586 27.6532C13.7137 26.7415 12.5562 25.4403 11.8195 23.8994Z",
    fill: "#0069D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutPie);
export default __webpack_public_path__ + "static/media/donut_pie.0d07393d1788a7cb3b142b7205939ce5.svg";
export { ForwardRef as ReactComponent };